import React from 'react';

import { withStyles } from '@material-ui/core/styles';


const styles = {
    container: {
        display: 'flex',
        alignItems: 'flex-start',
        flexWrap: 'nowrap',
        width: '100%',
        '& > *:first-child': {
            flex: '1 1 auto',
            minWidth: 0
        }
    }
};

class FieldWithHelp extends React.Component {
    render() {
        const c = this;
        const { show = true, children, classes } = c.props;

        if (!show) {
            return null;
        }

        return <div className={classes.container}>
            {children}
        </div>;
    }
}

export default withStyles(styles)(FieldWithHelp);
